export default __webpack_public_path__ + "static/media/logo-dark.5737a6d8.png";